// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__I-K71","footerContent":"footer_footerContent__SX59U","poweredBy":"footer_poweredBy__KsaIy","copyright":"footer_copyright__Lg0XK"};